import { Grid, Typography } from '@mui/material';
import { usePqrData } from './hook';
import { PqrDataProps } from './props';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';
import { Dialog } from '../../../../../components/general/dialog/dialog';

export const PqrData = (props: PqrDataProps) => {
    const {
        formik,
        branches,
        receptionChannels,
        types,
        halfs,
        subtypeDps,
        procedures,
        isOpen,
        name,
        extra,
        handleClose,
    } = usePqrData(props);

    return (
        <>
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                pt="20px"
            >
                <Grid item xs={12}>
                    <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                        Datos PQR
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(branches)}
                        label="Sucursal de expedición"
                        name="branch"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.branch}
                        errors={formik.errors.branch}
                        value={formik.values.branch}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('branch', value)
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(receptionChannels)}
                        label="Canal de recepción"
                        name="receptionChannel"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.receptionChannel}
                        errors={formik.errors.receptionChannel}
                        value={formik.values.receptionChannel}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('receptionChannel', value)
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(types)}
                        label="Tipo PQR"
                        name="type"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.type}
                        errors={formik.errors.type}
                        value={formik.values.type}
                        onChangeValue={(value: any) => {
                            formik.setFieldValue('type', value);
                            props.onTypeChange?.(value ?? null);
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(halfs)}
                        label="Medio"
                        name="half"
                        size="small"
                        required
                        disabled={halfs.length === 0}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.half}
                        errors={formik.errors.half}
                        value={formik.values.half}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('half', value)
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(subtypeDps)}
                        label="Subtipo DP"
                        name="subtypeDp"
                        size="small"
                        required
                        disabled={subtypeDps.length === 0}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.subtypeDp}
                        errors={formik.errors.subtypeDp}
                        value={formik.values.subtypeDp}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('subtypeDp', value)
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={formatParams(procedures)}
                        label="Trámite"
                        name="procedure"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.procedure}
                        errors={formik.errors.procedure}
                        value={formik.values.procedure}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('procedure', value)
                        }
                    />
                </Grid>
            </Grid>
            {isOpen && (
                <Dialog
                    title={name || ''}
                    open={isOpen}
                    onClose={handleClose}
                    maxWidth="sm"
                >
                    {extra}
                </Dialog>
            )}
        </>
    );
};
